import React, { useState, useEffect } from 'react';
import { Table, Card, Row, Col } from 'antd';
import getSetting from '../../api/getSettings';
import getCompanyIdFromToken from '../../utils/getCompanyIdFromToken';

const CompanySettingDetails = () => {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const companyId = getCompanyIdFromToken();
    console.log("cId", companyId);


    const fetchTableData = async () => {
        setLoading(true);
        try {
            const response = await getSetting();
            if (response?.result?.length) {
                console.log("API Response", response.result);
                
                // If companyId is 1, show all records, else filter
            const matched = companyId === 1
                ? response.result
                : response.result.filter(
                    item => String(item.id ?? item.client_Id) === String(companyId)
                );
                console.log("matched, ", matched);
                
                // const formattedData = response.result.map((item, index) => ({
                const formattedData = matched.map((item, index) => ({
                    serial: index + 1,
                    company_name: item.company_name,
                    tag_line: item.tag_line,
                    address: item.address,
                    phone: item.phone,
                    email: item.email,
                    website: item.website,
                    footer: item.footer,
                    officeTypeId: item.officeTypeId,
                    gst: item.gst
                }));
                setTableData(formattedData);
            }
        } catch (error) {
            console.error("Error fetching table data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTableData();
    }, []);

    const columns = [
        {
            title: 'S.No',
            dataIndex: 'serial',
            key: 'serial',
        },
        {
            title: 'Company Name',
            dataIndex: 'company_name',
            key: 'company_name',
        },
        // {
        //     title: 'Tag Line',
        //     dataIndex: 'tag_line',
        //     key: 'tag_line',
        // },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        // {
        //     title: 'Website',
        //     dataIndex: 'website',
        //     key: 'website',
        // },
        // {
        //     title: 'Footer',
        //     dataIndex: 'footer',
        //     key: 'footer',
        // },
        // {
        //     title: 'GST',
        //     dataIndex: 'gst',
        //     key: 'gst',
        // },
    ];

    return (
        <Row className="mr-top" justify="center">
            <Col >
                {/* <Card title="Office Settings List" bordered={false}> */}
                <Table
                    columns={columns}
                    dataSource={tableData}
                    rowKey="serial"
                    loading={loading}
                    pagination={{
                        pageSize: 10,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '30']
                    }}
                />
                {/* </Card> */}
            </Col>
        </Row>
    );
};

export default CompanySettingDetails;